type OpenWindow = (
  url?: string | URL,
  target?: string,
  features?: string,
) => Window | null;

/**
 * Creates the new tab while the current Website tab is still its opener so the
 * browser copies this tab's sessionStorage. The opener is detached immediately
 * before navigation, leaving the new tab isolated after that one-time handoff.
 */
export const openDetachedTabWithSessionCopy = (
  url: string,
  openWindow: OpenWindow = window.open.bind(window),
): boolean => {
  const targetWindow = openWindow("about:blank", "_blank");
  if (!targetWindow) return false;

  targetWindow.opener = null;
  targetWindow.location.href = url;
  return true;
};
